<div id="$5-credit-perk-template">
    <div class="coupon-grid-offer">
        <div class="grid-coupon-container credit-preview-container">
            <div class="grid-wrapper">
                <div class="credit-preview-heading-container">
                    <div class="credit-preview-heading">
                        <span class="credit-title-text">{{properties.confirmation.DON_T_MISS_OUT_ON_FREE_SAVINGS}}</span>
                    </div>
                    <div class="credit-preview-icon">
                        <span aria-hidden="true" class="img-subs" role="img">
                            <img alt="freshpass personalized savings icon"
                                 aria-hidden="true" src="ocsp-web-ui/dist/assets/images/5-credit-badge-small.svg">
                        </span>
                    </div>
                </div>
                <div class="credit-preview-details">
                    <span class="credit-details-text">{{properties.confirmation.FRESH_PASS_ANNUAL_PLAN_SUBSCRIBERS_GET_A_5_CREDIT_EVERY_MONTH}}</span>
                </div>
                <div id="credit-preview-status">
                    <div *ngIf="creditPreviewStatus === 'annual'; else creditMonthlyStatus">
                        <p>{{properties.confirmation.AVAILABLE_TO_YOU}}: {{annualCreditDate}}</p>
                    </div>
                    <ng-template #creditMonthlyStatus>
                        <div class="btn-container">
                            <span (click)="goToChangePlan()" (keydown.enter)="goToChangePlan()"
                                  class="credit-preview-btn"
                                  role="button"
                                  tabindex="0"
                            >{{properties.confirmation.UPGRADE_NOW}}</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
